import { useTranslation } from 'react-i18next';
import { Box, Button, Chip, Grid, Hidden, Link, Stack, Typography, useTheme } from '@mui/material';
import CardComponent from '../../components/Card';
import {  AddCircleLineIcon, ArrowRightSIcon, CommunityMembersIcon, iconFontSize} from '../../components/IconComponent';
import { GetIconColor } from '../../theme/main_style';
import Container from '../../components/Container';
import SubHeader from '../../components/SubHeader';
import { useNavigate } from 'react-router-dom';
import { config_path } from '../../router/config.path';
import { replaceParamTranslation } from '../../utils/util';
import { checkActionPermission } from '../../utils/common';
import { cache } from '../../utils/cache';

export default function CommunitiesView2(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { fromMenuProfile, groups, joinedGroups } = props
    const { palette } = useTheme();
    const appConfig = cache.getAppConfig();
    const isSupportCreateCommunities = appConfig&& appConfig.features&& appConfig.features.contact && appConfig.features.contact.contact && appConfig.features.contact.contact.communities && appConfig.features.contact.contact.communities.is_supported;

    const onBack = () => {
        if(props.from == 'my_plans') {
            navigate(config_path.my_plans)
        } else {
            navigate(config_path.home)
        }
    }
    let isAllowActions = checkActionPermission("CONTACT_MANAGEMENT")

    const renderRoot = () => {
        return (

            <>
                <Hidden mdDown>
                    <Container showProcessing={props.showLoading} showFooter showHeader subHeader={<SubHeader title={fromMenuProfile ? t('switch_roles') : t('communities')} />}>
                        {fromMenuProfile ? 
                            <Typography fontSize={'medium'} fontFamily={'Roboto-Regular'} marginTop={-4} marginBottom={3}>{t('communities_switch_role_desc')}</Typography> : 
                            <Typography fontSize={'medium'} fontFamily={'Roboto-Regular'} marginTop={-4} marginBottom={3}>{t('communities_desc')}</Typography>
                        }
                        {!fromMenuProfile && 
                        <>
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="flex-end"
                                marginRight={2}
                            >
                                {isSupportCreateCommunities &&
                                <Grid xs={12} item container justifyContent={'flex-end'} alignItems={'center'}>
                                    <Stack flex={0.5} direction={'row'} justifyContent='flex-end'>
                                        {<Link onClick={() => props.onCreateNewGroup()} id='create_community'>+ {t('create_community')}</Link>}
                                    </Stack>
                                </Grid>}
                            </Stack>
                            {renderContent()}
                        </>
                        }
                        {fromMenuProfile && renderSwitchRoleContent()}

                    </Container>
                </Hidden>
                <Hidden mdUp>
                    <Container showProcessing={props.showLoading}  mobileHeader={{
                        show: true,
                        title: fromMenuProfile ? t('switch_roles') : t('communities'),
                        onBack: () => onBack(),
                    }}>
                        {fromMenuProfile ? <Typography marginBottom={3}>{t('communities_switch_role_desc')}</Typography> : <Typography marginBottom={3}>{t('communities_desc')}</Typography>}
                        {fromMenuProfile && renderSwitchRoleContent()}
                        {!fromMenuProfile &&
                        <>
                            {renderContent()}
                            {isSupportCreateCommunities &&
                            <Stack direction="row" alignItems="center" justifyContent="center" sx={{position: 'fixed', bottom: '50px', left: 0, width: '100%', px: 2, zIndex: 200 }}>
                                <Button sx={{ color:palette.common.white }} fullWidth color='primary' variant="contained" id="createCommunity/Submit" borderRadius={'50%'}
                                    onClick={() => props.onCreateNewGroup()} 
                                    startIcon={<AddCircleLineIcon color={GetIconColor().white} size= {iconFontSize.xs}/>}>
                                    {t('create_community')}
                                </Button>
                            </Stack>}
                        </> 
                        }
                    </Container>
                </Hidden>
            </>
        )
    }

    const renderContent = () => {
        return (
            <>
                {(!groups || groups.length === 0) ? 
                    <Box sx={{ marginTop: 2 }}>
                        <Typography>{t('no_communities_yet')}</Typography>
                    </Box>
                    : 
                    <>
                    {groups.map((item, index) => (
                        <Box
                            key={`${index}`}
                            mb={1}
                            borderBottom={groups.length - 1 === index ? 0 : `1px solid ${palette.border.main}`}
                            onClick={() => props.onSeeMembers(item)}
                            sx={{ cursor: "pointer" }}
                        >

                            <CardComponent paddingY={1} noBorder paddingTop={0}>
                                <Stack direction="row" alignItems="center" justifyContent="space-between">
                                    <Stack direction="row" alignItems="center">
                                        <CommunityMembersIcon sx={{ marginRight: 5 }}color={GetIconColor().default}/>
                                        <Stack marginLeft={2} spacing={0} marginBottom={1}>
                                            <Typography variant='subtitle1'>{item.group}</Typography>
                                            {item.isOwner ? 
                                            <Chip size='small' sx={{ background: palette.primary.light, padding: 0, height:'18px' }} label={replaceParamTranslation(t('ownedBy'), [t('you')])} /> :
                                            <Chip size='small' sx={{ background: palette.secondary.light, padding: 0, height:'18px' }} label={replaceParamTranslation(t('ownedBy'), [item.ownerName])} />
                                        }
                                        </Stack>
                                    </Stack>
                                    <ArrowRightSIcon />
                                </Stack>
                            </CardComponent>
                        </Box>
                    ))}

                    </>
                }
            </>
        )
    }

    const renderSwitchRoleContent = () => {
        return (
            <>
                {(!joinedGroups || joinedGroups.length === 0) ? 
                    <Box sx={{ marginTop: 2 }}>
                        <Typography>{t('no_communities_yet')}</Typography>
                    </Box>
                    : 
                    <>
                    {joinedGroups.map((item, index) => (
                        <Box
                            key={`${index}`}
                            mb={1}
                            borderBottom={joinedGroups.length - 1 === index ? 0 : `1px solid ${palette.border.main}`}
                            onClick={isAllowActions ? () => props.onSwitchRole(item) : undefined}
                            sx={{ cursor: "pointer" }}
                        >

                            <CardComponent paddingY={1} noBorder paddingTop={0}>
                                <Stack direction="row" alignItems="center" justifyContent="space-between">
                                    <Stack direction="row" alignItems="center">
                                        <CommunityMembersIcon sx={{ marginRight: 5 }}color={GetIconColor().default}/>
                                        <Stack marginLeft={2} spacing={0} marginBottom={1}>
                                            {
                                                item.community_owner.first_name && item.community_owner.last_name ?
                                                <Typography variant='subtitle1'>{item.community_owner.first_name + ' ' + item.community_owner.last_name}</Typography> :
                                                <Typography variant='subtitle1'>{item.community_owner.first_name}</Typography>
                                            }
                                            {item.group && <Box mt={0.5}>
                                            <Chip size='small' sx={{ background: palette.primary.light, padding: 0, height:'18px' }} label={item.group} /></Box>}
                                            <Box mt={1}>
                                                <Chip size='small' sx={{ background: palette.secondary.light, padding: 0, height:'auto', mt:1, whiteSpace:'break-spaces' }} label={item.access_level} />
                                            </Box>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </CardComponent>
                        </Box>
                    ))}

                    </>
                }
            </>
        )
    }
    return (
        <>{renderRoot()}</>
    )
}
